import type { FaireProductEntity } from "../../entity_types/product";

export const p_5jqtfryt5j: FaireProductEntity = {
  token: "p_5jqtfryt5j",
  type: "product",
  name: "Occult and Curious 1000 Piece Glow in the Dark Puzzle",
  brandToken: "b_xhktv33sen",
  brandName: "Chronicle Books",
  imageUrl:
    "https://cdn.faire.com/fastly/2c081ba9614fa8a92347d235c00b774e3e5d8e7acd531059b1ee2b9e6441535b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3bd1abdac4283a0a51a970e6a83da33fe733b6e8082399bd5470e890880bd4b2.jpeg",
    "https://cdn.faire.com/fastly/26d341cebebd5679690af8e88a533fb822238c8df61c22d6c2bbb3cabc84b994.jpeg",
    "https://cdn.faire.com/fastly/da2d74136174f8b989201c27991c4fa61b30de858e66d8ff73c1aaf28adc9b89.jpeg",
  ],
  priceDollars: 10.39,
  description:
    "1000 Piece Puzzle – Occult & Curious 1000 Piece Glow In The Dark Puzzle by Galison features a full color glossary of curiosities enhanced with Glow In the Dark Ink. Assemble the puzzle, turn out the lights and prepare to see a glow in the dark variation! This puzzle is just the right level of challenge for the whole family to join in on for hours of puzzling fun! The box includes an insert with the full puzzle image for reference.\n\nBright and Bold Artwork – This puzzle features an eerie collection of weird and mystical objects, spiking a supernatural curiosity. Puzzle lovers will appreciate all the interesting details as they piece together the puzzle, creating a spooky display that will add a touch of weirdness to any room this spooky fall season.",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:31.388Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
